import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react-lite';
import { useStore } from '../../../store/index';
import { HeartIcon } from './HeartIcon';

const FavoriteIconComponent = ({ candidate }) => {
  const {
    favoritesStore: {
      isFavorited,
      userInitiatedFavorites,
      userInitiatedUnFavorites,
      toggleCandidateFavoriteStatus
    }
  } = useStore();

  const [favorited, updateFavorited] = useState(isFavorited(candidate));

  useEffect(() => {
    updateFavorited(isFavorited(candidate));
  }, [userInitiatedFavorites.size, userInitiatedUnFavorites.size]);

  function updateFavorite(e) {
    e.stopPropagation();
    toggleCandidateFavoriteStatus(candidate);
  }

  return (
    <div
      onMouseUp={updateFavorite}
      data-testid={`favorite-icon-${candidate.candidateId}-${favorited ? 'enabled' : 'disabled'}`}
      className="slm-favorite-icon__container"
    >
      <HeartIcon active={favorited} />
    </div>
  );
};

FavoriteIconComponent.propTypes = {
  candidate: PropTypes.shape({
    candidateId: PropTypes.number.isRequired
  })
};

FavoriteIconComponent.defaultProps = {
  candidate: {}
};

export const FavoriteIcon = observer(FavoriteIconComponent);
